module.exports = fox._r("images/social_icons/ico-tw.png", __webpack_public_path__ + "_/_/_/root/images/social_icons/ico-tw.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/social_icons/ico-tw.png
// module id = 947
// module chunks = 4